export default [
  '/api/index/collectRecommend', //首页专辑
  '/api/index/hotCategory', // 2104-分类视频推荐
  '/api/index/hotItem', // 2103-热门视频推荐
  '/api/index/collectChoice', // 2102-获取首页精选收藏单
  '/api/collect/list', //2301-所有专辑列表（专辑广场）
  '/api/collect/userCollectList',
  '/api/items/list', //2201-内容列表
  '/api/items/detail', //2202-内容详情
  '/api/index/getSmallVideo', // GET 获取小视频
  '/api/items/ownerInfo', // 2204-内容详情--店铺信息
  '/api/collect/itemList', //2302-专辑详情列表
  '/api/collect/itemData', //专辑详情列表--item信息
  '/api/trade/addCart|post', //3101-添加内容到购物车
  '/api/trade/getCart', //3103-获取购物车内容
  '/api/common/userPhoneLoginReg|post', // 0103-用户手机号码登录/注册
  '/api/common/sendUserSmsCode|post', // 0103-获取登录注册验证码
  '/api/user/getUserCollect', // 1201用户所有专辑
  '/api/user/addItemToCollect|post', // 1202添加到用户专辑
  '/api/user/addCollect|post', // 1203添加新专辑
  '/api/common/getUserInfo', // 0101-获取登录状态
  '/api/trade/confirmOrder', // 3107-发起交易-确认订
  '/api/trade/delCart|post', //3102-删除购物车条目
  '/api/trade/cartItemChecked|post', //3105-更新购物车选中状
  '/api/trade/cartItemBuyType|post', //3106-更新购物车购买类型
  '/api/user/myCollectList', //1303-01-我的专辑
  '/api/trade/confirmOrder', //3107-发起交易-确认订单
  '/api/user/myUserInfo', // 1101-01-个人资料信息
  '/api/user/modifyUserInfo|post', // 1101-02-个人资料信息修改
  '/api/user/uploadUserPhoto|post', // 1101-03-个人资料信息修改（头像）
  '/api/trade/submitOrder|post', //3108-发起交易-提交订单
  '/api/trade/pay|post', //3109-发起交易-支付**
  '/api/trade/payCallback|post', //3110-发起交易-支付回调**
  '/api/trade/payBack|post', //3110-发起交易-支付回调**
  '/api/items/category', // 2203-获取视频类目树
  '/api/img/category', // 2203-获取图片类目树
  '/api/img/createItem|post', // 上传图片作品
  '/api/img/selectList', //查询所有草稿上传列表
  '/api/img/allItems', //查询所有已提审核上传列表
  '/api/img/deleteImgItem|post', // 删除图片素材
  '/api/user/myUserCertificate', // 1103-01-用户认证状态
  '/api/user/myUserCertificatePerson', // 1103-02-获取用户认证信息（个人认证）
  '/api/user/postUserCertificatePerson|post', // 1103-03-提交个人认证信息
  '/api/user/myUserCertificateEnterprise', // 1103-04-获取用户认证信息（企业认证）
  '/api/user/postUserCertificateEnterprise|post', // 1103-05-提交企业认证信息
  '/api/order/myOrderList', //1301-订单中心（我的订单）
  '/api/user/getFileUploadService', // 1402-00-获取文件上传接口地址
  '/api/user/getOssFileUploadService', // 1402-00-获取文件上传接口地址
  '/api/copyright/getOssFileUploadService', // 1402-00-获取文件上传接口地址
  '/api/user/verification|post', //检查md5
  '/api/trade/getOssFileDownloadService', // 获取文件下载
  '/api/user/infoTranscode|post', // 1402-00-获取文件上传接口地址
  // '/api/user/insertItem|post', // 创建数据
  '/api/public/upload|post', //上传图片
  '/api/user/postItemInfo|post', //1402-02-提交新内容 创建素材
  '/api/user/updateAll|post', // 批量修改
  '/api/user/commitAll|post', // 批量提交审核
  '/api/common/userPasswordLogin|post', // 0104-密码登录
  '/api/common/logout|post', // 退出登录
  '/api/doc/getDocument', //8101-获取文档内容
  '/api/user/myUserAccount', // 1102-01-账号安全信息
  '/api/user/sendUpdateSmsCode|post', // 修改密码前发送验证码
  '/api/user/modifyUserAccountPhone|post', // 修改密码前验证一下验证码
  '/api/user/myFavoriteChangeItem|post', // 修改密码前验证一下验证码
  '/api/user/myCollectRemove|post', // 修改密码前验证一下验证码
  '/api/user/modifyUserAccount|post', // 修改密码前验证一下验证码
  '/api/doc/getLevelTitle', //获取文档tab
  '/api/user/myCollectItemList', // 我的专辑详情
  '/api/user/detail', // 我的作品详情
  '/api/user/allItems', // 我的作品列表
  '/api/user/deleteItem|post', //删除作品
  '/api/user/myCollectRemoveItem|post', // 1304-02-从我的某张专辑移除内容
  '/api/downLoad/demoDownLoad', // 下载文件
  '/api/items/usersItem',
  '/api/trade/downLoad', // 下载付费文件
  '/api/user/selectList', // 获取上传列表
  '/api/user/deleteList|post', // 删除未编辑的素材
  '/api/user/getCoverImgs', // 获取封面
  '/api/order/getAmount', //获取用户金额（总消费、开票）
  '/api/user/getInvoiceInfo', //开票抬头查询
  '/api/user/updInvoiceInfo|post', //开票抬头编辑
  '/api/order/invoicedQuery', //可开票的订单查询
  '/api/orderInvoice/invoicedOrderQuery', //已开票的订单查询
  '/api/orderInvoice/orderInvoicing|post', //订单开票
  '/api/user/getWithdrawableAmount', //用户可提现金额查询
  '/api/userDeposit/getWithdrawalRecord', //提现记录查询
  '/api/user/getPaymentMethod', //获取用户提现收款方式
  '/api/user/updPaymentMethod|post', //用户提现收款方式修改
  '/api/invoicing/changePayAccount|post', //修改提现银行卡号
  '/api/userDeposit/withdrawalNew|post', //用户提现
  '/api/order/getAmount', //获取用户金额（总消费、开票）
  '/api/user/getInvoiceInfo', //开票抬头查询
  '/api/user/updInvoiceInfo|post', //开票抬头编辑
  '/api/order/invoicedQuery', //可开票的订单查询
  '/api/orderInvoice/invoicedOrderQuery', //已开票的订单查询
  '/api/items/evidence', //获取证据
  // '/api/excel/download|post', //导出已上传素材
  '/api/excel/upload|post', // 上传素材
  '/api/excel/export', // 导出任务
  '/api/excel/list', // 查询是否有可下载文件
  '/api/excel/downLoad', //导出已上传素材
  '/api/excel/select', // 查询上传结果
  '/api/user/userItemCount', // 获取用户素材数据
  '/api/index/usernameSearch', //搜索用户
  '/api/items/suggester', // 搜索联想词
  '/api/common/getQrCode', // 获取微信登录二维码
  '/api/common/checkLogin|post', // 检查登录状态
  '/api/user/itemSort|post', // 修改作品权重
  '/api/common/phone|post', // 绑定手机号
  '/api/common/sendUserSmsCodeBind|post', // 绑定手机号
  '/api/protection/evidence|post', //版权存证表单
  '/api/protection/registration|post', //版权登记表单
  '/api/order/appForAuth|post', //申请授权书
  '/api/order/getAppForAuthInfo', //获取用户上一次申请授权书填写信息
  '/api/order/getAppForAuth', //查询授权记录
  '/api/wallet/recharge/amount|post', //充值
  '/api/wallet/balance', //账户余额
  '/api/wallet/recharge/status', //充值查询接口
  '/api/wallet/compute|post', //余额和商品价格计算
  '/api/sonConfig/queryList', //查看子账号列表
  '/api/sonConfig/adjustSonAmount|post', //调整子账号额度
  '/api/order/getOrderDetails', //获取订单信息
  '/api/userDownAuth/get', //获取用户年包授权信息
  '/api/discount/my|post', //我的优惠券
  '/api/userDeposit/cashOrderQuery', //可提现订单查询
  '/api/user/joinYearPackPool|post', //加入|退出 年包池
  '/api/order/getForAuth', //获取授权书
  '/api/items/similar/recommend', //相关推荐
  '/api/baidu/uploadConvertData|post', // 百度
  '/api/user/invite/list', //邀请列表
  // 版权保护
  '/cr/vip/list', // 查询可开通会员列表
  '/api/protection/monitoring|post', // 版权监测
  '/api/copyright/pay|post', //存证支付 -- web
  '/api/copyright/payCallback|post', // 发起交易-支付回调
  '/api/copyright/getCrPrice', // 获取定价
  '/api/protection/queryMonitoring', // 版权监测记录分页查询
  '/api/protection/queryRegistration', // 版权登记记录分页查询
  '/api/protection/queryNotarization', // 数字公证记录分页查询
  '/api/weChat/getSignature|post', // 分享
  '/api/pdf/getRegistrationWeb', // 版权登记证书Web
  '/api/pdf/getCertificateWeb', // 版权存证证书
  '/api/pdf/evidencePdf', // 电子版权存证证书
  '/api/sps|post', // 集合版权计划
  '/api/sps/check/params|post', // 集合版权计划数据完整检查
  '/api/sps/draft/list', // 集合作品数据草稿列表
  '/api/sps/query', // 集合作品获取指定草稿数据
  '/api/sps/sing|post', // 甲方签署
  '/api/docx/getAgreement', // 集合作品服务协议下载
  '/api/sps/queryLastData', //获取上次填写的数据
  '/api/sps/del|delete', //删除草稿
  '/api/sps/snapshot|post', //通知截图
  '/api/sps/querySnapshot|post', //查询截图
  // 社区接口
  '/community/position/position', // 获取职务列表
  '/community/worksUser/collectPage', // 社区
  '/api/copyright/registration|post', //著作权人登记
  '/api/copyright/enquiries', //查询著作权人

  '/userRegist/behavioralAnalysis', //用户注册行为分析
  '/api/protection/queryEvidence', //版权存证记录分页查询

  '/api/eventTracking/browsingHistory|post', //用户素材浏览记录埋点
  '/api/history/getBrowsingHistory', //获取用户浏览记录

  '/api/ali/getToken', //阿里云客服获取token
  '/api/trade/isBuy|post', //查询商品是否被购买
  '/api/order/deleteOrder|post', //订单删除

  '/api/protection/notarization|post', //新增数字公证
  '/api/crScheme/qureyScheme', //集合版权计划分页查询
  '/api/crScheme/qureySchemeById', //集合版权计划详情查询
  '/api/copyright/my/order', //版权保护 我的订单
  '/api/copyright/order/detail', //版权保护 我的订单查看
  '/api/pdf/getCertificate', //存证证书下载
  '/api/protection/monitor/result', //监测结果
  '/api/protection/dci|post', //dci版权登记
  '/api/common/sendUserSmsCodeDci|post', //用户发送短信
  '/api/dci/addDCIUser|post', //新增dci用户
  '/api/dci/getDciUserList', //查询dci用户
  '/api/protection/queryDci', //dci登记列表查询
  '/api/protection/getDciInfo', // 获取DCI登记信息
  '/api/protection/digitalRegistration|post', // DCI 国版数字登记
  '/api/copyright/getDownload', //下载dci证书
  '/api/invite/getUserInfo|post', //集合版权海报信息
  '/api/discount/list', //折扣列表
  '/api/protection/getCreationTypes', // 存证作品类型字典
  '/api/protection/monitoringVideo|post', // 版权监测（视频）
  '/api/protection/queryMonitoringVideo', //版权监测（视频）记录分页查询
  '/api/protection/monitorVideo/result', // 版权检测结果（视频）
  '/api/public/recognizePerson|post', // 身份证自动识别
  '/api/public/recognizeCompany|post', // 营业执照
  '/api/copyright/addOrder|post', // 生成订单
  '/api/copyright/findBusiness', //版权保护根据类型和id获取业务数据

  '/ct/getOrderList', //版权交易订单列表
  '/resource/card/exchange|post', // 兑换优惠券
  '/resource/card/page', // 兑换优惠券
  '/api/ucra/available/list', // 用户优惠券生效列表
  '/api/ac/getCode', // 地区编码
  '/cer/evidence',
  '/api/copyright/validityPeriod|post', //修改著作权人
  '/api/protection/evidenceEle|post', // 电子证书
  '/api/copyright/findCopyrightOwnerInfo', // 获取著作权人

  '/api/screenshot/save|post', // 网页取证创建订单
  '/api/screenshot/notary/list', // 公证处列表
  '/api/screenshot/list', //取证订单
  '/api/screenshot/order/form', //取证订单详情
  '/api/screenshot/queryScreenshot', //查询网页取证结果
  '/api/screenshot/queryRecordResult', //查询录屏取证证据包
  '/api/screenshot/repay|post', // 继续支付
  '/api/screenshot/queryOperationUrl', // 查询录屏操作url
  '/excel/monitoringResultsExported|post', // 导出监测结果
  // 版权图片相关接口
  '/api/user/user/invite/code', //获取用户邀请码
  '/api/img/pack/packList', //用户购买的图片套餐列表
  '/api/img/pack/logList', //用户使用图片套餐的消费记录列表
  '/api/img/pack/authRequest|post', //申请图片授权书
  '/api/img/pack/downAuth', //图片授权书下载
  '/api/img/pack/imgDownLogList', //图片下载记录列表
  '/api/img/pack/imgDown', //下载图片
  '/api/img/pack/configList', //图片套餐配置列表
  '/api/img/order/create/order|post', //购买套餐
  '/img/bonus/remainder', // 图片收益分成收益-待提取
  '/img/bonus/extract', // 提取图片收益
  '/img/bonus/list', // 收益明细
  '/api/img/join/broker|post', //关联图片素材经纪人
  '/api/img/broker/author/upload_detail', //经纪人关联创作者上传明细
  '/api/img/order/invite/consume/detail', //邀请用户消费信息

  //版权和图片专区相关开票接口
  '/api/orderInvoice/protectionOrderQuery', //版权保护订单开票列表查询
  '/api/orderInvoice/imgPackOrderQuery', //图片专区会员开票列表查询
  '/api/orderInvoice/protectionOrderInvoicing|post', //版权保护订单开票
  '/api/orderInvoice/imgPackOrderInvoicing|post', //图片专区会员开票
  '/dc/get', //查字典接口

  // 接口跳转
  '/api/common/login/auth_code|post', // 授权码登陆

  // 知产溯源平台
  '/api/copyrightSource/formSubmission|post', // 创意保护表单提交
  '/api/copyrightSource/sourcePage', //创意保护分页查询
  '/api/copyrightSource/getById',
  '/api/copyrightSource/getPdf',
  '/api/copyrightSource/productNamePage',

  // 提现
  '/api/invoicing/addMembers|post', //
  '/api/invoicing/type',
  '/api/fileUpload/upload|post', // 上传图片
  '/api/invoicing/getUserAgreement', // 获取协议
  '/api/invoicing/userAgreementAuthorization|post', // 签名
  '/api/invoicing/getMembers',
];
